import { matchPath } from "react-router-dom";

import { ROUTES } from "@router/router.constants";

export const isCustomersRoute = (pathname: string) =>
  matchPath(ROUTES.PERIMETER_CUSTOMERS, pathname)?.pattern.end;

export const isCustomerRoute = (pathname: string) =>
  matchPath(ROUTES.PERIMETER_CONTRACTS_BY_CUSTOMER, pathname)?.pattern.end;

export const isContractsRoute = (pathname: string) =>
  matchPath(ROUTES.PERIMETER_CONTRACTS, pathname)?.pattern.end;

export const isContractRoute = (pathname: string) =>
  matchPath(ROUTES.PERIMETER_SITES_BY_CONTRACT, pathname)?.pattern.end;

export const isSitesRoute = (pathname: string) =>
  matchPath(ROUTES.PERIMETER_SITES, pathname)?.pattern.end;

export const isSiteRoute = (pathname: string) =>
  matchPath(ROUTES.PERIMETER_SITE, pathname)?.pattern.end;
